import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./editScenarioNewSlice";
import { useEffect } from "react";

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
const percentText = "(%)";
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		},
	},
};

function getStyles(name, sources, theme) {
	return {
		fontWeight:
			sources.indexOf(name) === -1
				? theme.typography.fontWeightRegular
				: theme.typography.fontWeightMedium,
	};
}

export default function MultipleSelectChipType() {
	const theme = useTheme();

	const { customerTypes, selectedcustomerTypes,filteredCustomerTypes, selectedCustsCGs,SafetyMargin } = useSelector(
		(store) => store.editScenarioNew
	);
	const dispatch = useDispatch();

	useEffect(()=>{
		const distinctCustomerTypeCodes = [
			...new Set(
				selectedCustsCGs.filter(
					(item) => item.type === "C" || item.hasOwnProperty("customerID")
				  ).map(customer => customer.customerTypeCode)
			)
		];
		//// || customer.customerGroupTypeCode
		const filtered = customerTypes.filter(type => distinctCustomerTypeCodes.includes(type.customerTypeCode));
		dispatch(setState("filteredCustomerTypes", filtered));
	}, [selectedCustsCGs]);

	useEffect(()=>{
		const distinctCustomerTypeCodes = [
			...new Set(
				filteredCustomerTypes.map(customer => customer.customerTypeName)
			)
		];
		let filtered = selectedcustomerTypes.filter(type => distinctCustomerTypeCodes.includes(type));
		dispatch(setState("selectedcustomerTypes", filtered));
	},[filteredCustomerTypes]);

	const showMessage = (message, severity) => {
		dispatch(setState("message", message));
		dispatch(setState("severity", severity));
		dispatch(setState("messageOpen", true));
	};

	const handleChange = (event) => {
		if (selectedCustsCGs.length <= 0) {
			showMessage(
				"Please select at least one customer or customer group",
				"info"
			);
			return;
		}
		const {
			target: { value },
		} = event;

		dispatch(
			setState("selectedcustomerTypes", value === "string" ? value.split(",") : value)
		);
		const safetymargin = [];
		if(value!=undefined && value!=null && value!=""){
			const selectedTypes = value === "string" ?value.split(","): value;
			for( let i = 0; i< selectedTypes.length; i++){
				const TypeCode = filteredCustomerTypes.find(x => x.customerTypeName === selectedTypes[i]).customerTypeCode;
				const list = {type: selectedTypes[i], safetyMargin: '', typeCode: TypeCode};
				let idx = SafetyMargin.findIndex(x => x.type === selectedTypes[i]);
				if(idx === -1){
					safetymargin.push(list);					
				}
				else{
					safetymargin.push(SafetyMargin[idx]);
				}
			}
		}
		//let cgList = {type: "Customer Group", safetyMargin: '', typeCode:"CustomerGroup"};
		let cgidx = SafetyMargin.findIndex(x => x.type === "Customer Group");
		if(cgidx > -1){
			safetymargin.push(SafetyMargin[cgidx]);			
		}
		
		dispatch(setState("SafetyMargin", safetymargin));
	};

	return (
		<div>
			<FormControl sx={{ width: "100%"}}>
				<InputLabel id="demo-multiple-chip-label">
					Default Safety Margin{percentText}
				</InputLabel>
				<Select
					labelId="demo-multiple-chip-label"
					id="demo-multiple-chip"
					multiple
					value={selectedcustomerTypes}
					onChange={handleChange}
					input={<OutlinedInput id="select-multiple-chip"label="Default Safety Margin %" />}
					renderValue={(selected) => (
						<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5,overflowY: "scroll", maxHeight: 70 }}>
							{selected.map((value, index) => (
								(index < 4 && <Chip key={value} label={value} />)
							))}
							{selected.map((value, index) => (
								(index === 4 && <Chip key={selected.length} label={`+ ${selected.length-4}` }/>)
							))}
						</Box>
					)}
					MenuProps={MenuProps}
				>
					{filteredCustomerTypes.map((source, index) => (
						<MenuItem
							key={index}
							value={source.customerTypeName}
							style={getStyles(
								source.CustomerType,
								selectedcustomerTypes,
								theme
							)}
						>
							{source.customerTypeName}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
}
